export default __webpack_public_path__ + "static/media/05-icon-laender.27e622cb.svg";